import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { ImageBox } from '../../ui/ImageBox';
import { galleryImages } from '../../../data/gallery';

/**
 * A strip of the gallery: one wide picture carrying the section and four
 * smaller ones beside it. Not a grid of five equal squares — that reads as
 * a contact sheet rather than an invitation.
 */
export function GalleryPreview() {
  const [lead, ...rest] = galleryImages.slice(0, 5);
  return <section aria-labelledby="gallery-preview-heading" className="bg-sand py-16 sm:py-24" data-id="element-252" data-mp="1xli3nskcjjoz">
      <div className="mx-auto max-w-container px-gutter-sm sm:px-gutter-md lg:px-gutter-lg" data-id="element-253" data-mp="1ip0w7cfa2p7p">
        <div className="flex flex-wrap items-end justify-between gap-6" data-id="element-254" data-mp="1nn2p0p2ia2wd">
          <div className="max-w-2xl" data-id="element-255" data-mp="1npf6700fw98d">
            <p className="mb-5 border-l-4 border-moss pl-3 text-sm font-black uppercase tracking-[0.2em] text-moss" data-id="element-256" data-mp="792pvgbhiha6">
              Gallery
            </p>
            <h2 id="gallery-preview-heading" className="font-bebas text-5xl leading-[0.9] tracking-wide text-ink sm:text-6xl" data-id="element-257" data-mp="c62m6zij85o3">
              Have a look round
            </h2>
            <p className="mt-4 max-w-prose text-lg leading-relaxed text-ink/80" data-id="element-258" data-mp="2n6dn35b61gpy">
              Stone walls, the collection hung on them, and the deck looking
              out across the valley.
            </p>
          </div>

          <Link to="/gallery" className="group inline-flex shrink-0 items-center gap-2 rounded-container border border-control px-5 py-3 text-sm font-bold text-ink transition-colors duration-200 ease-out-expo hover:bg-ink/5 focus:outline-none focus:ring-2 focus:ring-moss focus:ring-offset-2" data-id="element-259" data-mp="2x3ru6eb78t5l">
            All pictures
            <ArrowRight className="h-4 w-4 transition-transform duration-200 ease-out-expo group-hover:translate-x-1 motion-reduce:transform-none" aria-hidden="true" data-id="element-260" data-mp="31xnpf902w1x2" />
          </Link>
        </div>

        <div className="mt-12 grid gap-5 lg:grid-cols-[1.5fr_1fr]" data-id="element-261" data-mp="28jcx1t316h0p">
          <figure className="overflow-hidden rounded-container border border-hairline bg-white" data-id="element-262" data-mp="2ck572ojq8py1">
            <ImageBox src={lead.src} alt={lead.alt} ratio="16/9" data-id="element-263" data-mp="2hj8dacbg127l" />
            <figcaption className="border-t border-hairline px-4 py-3 text-sm text-ink-muted" data-id="element-264" data-mp="2hhot4amo270j">
              {lead.caption}
            </figcaption>
          </figure>

          <ul className="grid grid-cols-2 gap-5" data-id="element-265" data-mp="2r9updwjybalj">
            {rest.map(image => <li key={image.id} data-id="element-266" data-mp="2w7mmr63d7ox4">
                <ImageBox src={image.src} alt={image.alt} ratio="1/1" className="rounded-container border border-hairline" data-id="element-267" data-mp="2w6l004czldzk" />
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}